import { TiptapTransformer } from "@hocuspocus/transformer";
import { applyUpdate, Doc as YDoc } from "yjs";
import { extensions, extensionsRich } from "../server";

export function extractTipTapJSON(
  documentState: Uint8Array,
  ext: ReturnType<typeof extensionsRich> | ReturnType<typeof extensions>,
) {
  const ydoc = new YDoc();
  applyUpdate(ydoc, documentState);

  const content = TiptapTransformer.extensions(ext).fromYdoc(
    ydoc,
    "default",
  ) as Record<string, unknown>;

  return content;
}
